export default "__VITE_ASSET__vCDuNLz9__"